export const ArrowRightIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.05941 3.77344L12.2854 6.99944L9.05944 10.2255L8.44071 9.60678L10.6105 7.43694L2.33337 7.43696V6.56196L10.6105 6.56194L8.44069 4.39216L9.05941 3.77344Z"
      fill="currentColor"
    />
  </svg>
);
